/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-07 15:05:46
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-09 20:15:06
 */

export enum RecipeNormalFrequencyCategory {
  MRYT = '每日一帖',
  MRLT = '每日两帖',
  MRST = '每日三帖',
  MRSTS = '每日四帖',
  LRYT = '两日一帖',
  SRYT = '三日一帖',
}

export const RecipeNormalFrequencyCategories = [
  RecipeNormalFrequencyCategory.MRYT,
  RecipeNormalFrequencyCategory.MRLT,
  RecipeNormalFrequencyCategory.MRST,
  RecipeNormalFrequencyCategory.MRSTS,
  RecipeNormalFrequencyCategory.LRYT,
  RecipeNormalFrequencyCategory.SRYT,
]

export function RecipeNormalFrequencyName(
  recipeNormalFrequency: RecipeNormalFrequencyCategory
): string {
  switch (recipeNormalFrequency) {
    case '每日一帖':
      return '每日一帖'
    case '每日两帖':
      return '每日两帖'
    case '每日三帖':
      return '每日三帖'
    case '每日四帖':
      return '每日四帖'
    case '两日一帖':
      return '两日一帖'
    case '三日一帖':
      return '三日一帖'

  }
  return ''
}

export enum RecipeNormalUsemethodCategory {
  MTYC = '每帖一次',
  MTLC = '每帖两次',
  MTSC = '每帖三次',
  MTSCS = '每帖四次',
  MTSWC = '每帖五次',
  MTSLC = '每帖六次',
  MTSBC = '每帖八次',
}

export const RecipeNormalUsemethodCategories = [
  RecipeNormalUsemethodCategory.MTYC,
  RecipeNormalUsemethodCategory.MTLC,
  RecipeNormalUsemethodCategory.MTSC,
  RecipeNormalUsemethodCategory.MTSCS,
  RecipeNormalUsemethodCategory.MTSWC,
  RecipeNormalUsemethodCategory.MTSLC,
  RecipeNormalUsemethodCategory.MTSBC,
]

export function RecipeNormalUsemethodName(
  recipeNormalUsemethod: RecipeNormalUsemethodCategory
): string {
  switch (recipeNormalUsemethod) {
    case '每帖一次':
      return '每帖一次'
    case '每帖两次':
      return '每帖两次'
    case '每帖三次':
      return '每帖三次'
    case '每帖四次':
      return '每帖四次'
    case '每帖五次':
      return '每帖五次'
    case '每帖六次':
      return '每帖六次'
    case '每帖八次':
      return '每帖八次'
  }
  return ''
}

export enum RecipeNormalDoseCategory {
  MC10 = '每次10ml',
  MC20 = '每次20ml',
  MC50 = '每次50ml',
  MC80 = '每次80ml',
  MC100 = '每次100ml',
  MC120 = '每次120ml',
  MC130 = '每次130ml',
  MC140 = '每次140ml',
  MC150 = '每次150ml',
  MC160 = '每次160ml',
  MC170 = '每次170ml',
  MC180 = '每次180ml',
  MC200 = '每次200ml',
  MC300 = '每次300ml',
}

export const RecipeNormalDoseCategories = [
  RecipeNormalDoseCategory.MC10,
  RecipeNormalDoseCategory.MC20,
  RecipeNormalDoseCategory.MC50,
  RecipeNormalDoseCategory.MC80,
  RecipeNormalDoseCategory.MC100,
  RecipeNormalDoseCategory.MC120,
  RecipeNormalDoseCategory.MC130,
  RecipeNormalDoseCategory.MC150,
  RecipeNormalDoseCategory.MC160,
  RecipeNormalDoseCategory.MC170,
  RecipeNormalDoseCategory.MC180,
  RecipeNormalDoseCategory.MC200,
  RecipeNormalDoseCategory.MC300,
]

export function RecipeNormalDoseTypeName(
  recipeNormalDose: RecipeNormalDoseCategory
): string {
  switch (recipeNormalDose) {
    case '每次10ml':
      return '每次10ml'
    case '每次20ml':
      return '每次20ml'
    case '每次50ml':
      return '每次50ml'
    case '每次80ml':
      return '每次80ml'
    case '每次100ml':
      return '每次100ml'
    case '每次120ml':
      return '每次120ml'
    case '每次130ml':
      return '每次130ml'
    case '每次140ml':
      return '每次140ml'
    case '每次150ml':
      return '每次150ml'
    case '每次160ml':
      return '每次160ml'
    case '每次170ml':
      return '每次170ml'
    case '每次180ml':
      return '每次180ml'
    case '每次200ml':
      return '每次200ml'
    case '每次300ml':
      return '每次300ml'
  }
  return ''
}

//制丸
export enum RecipeTabletManufacturingCategory {
  MRYC = '每日一次',
  MRLC = '每日二次',
  MRSC = '每日三次',
  MRSCS = '每日四次',
  MRWC = '每日五次',
  MRLCL = '每日六次',
  LRYC = '两日一次',
  GRYC = '隔日一次',
  MZYC = '每周一次',
  MZLCZ = '每周两次',
  MZSC = '每周三次',
  GZYC = '隔周一次',
  BYSDF = '必要时顿服',
  SLPF = '少量频服',
  SSFY = '随时服用',
}

export const RecipeTabletManufacturingCategories = [
  RecipeTabletManufacturingCategory.MRYC,
  RecipeTabletManufacturingCategory.MRLC,
  RecipeTabletManufacturingCategory.MRSC,
  RecipeTabletManufacturingCategory.MRSCS,
  RecipeTabletManufacturingCategory.MRWC,
  RecipeTabletManufacturingCategory.MRLCL,
  RecipeTabletManufacturingCategory.LRYC,
  RecipeTabletManufacturingCategory.GRYC,
  RecipeTabletManufacturingCategory.MZYC,
  RecipeTabletManufacturingCategory.MZLCZ,
  RecipeTabletManufacturingCategory.MZSC,
  RecipeTabletManufacturingCategory.GZYC,
  RecipeTabletManufacturingCategory.BYSDF,
  RecipeTabletManufacturingCategory.SLPF,
  RecipeTabletManufacturingCategory.SSFY,
]

export function RecipeTabletManufacturingName(
  recipeTabletManufacturing: RecipeTabletManufacturingCategory
): string {
  switch (recipeTabletManufacturing) {
    case '每日一次':
      return '每日一次'
    case '每日二次':
      return '每日二次'
    case '每日三次':
      return '每日三次'
    case '每日四次':
      return '每日四次'
    case '每日五次':
      return '每日五次'
    case '每日六次':
      return '每日六次'
    case '两日一次':
      return '两日一次'
    case '隔日一次':
      return '隔日一次'
    case '每周一次':
      return '每周一次'
    case '每周两次':
      return '每周两次'
    case '每周三次':
      return '每周三次'
    case '隔周一次':
      return '隔周一次'
    case '必要时顿服':
      return '必要时顿服'
    case '少量频服':
      return '少量频服'
    case '随时服用':
      return '随时服用'
  }
  return ''
}

export enum RecipeTabletManufacturingNumCategory {
  MCSK = '每次3g',
  MCLK = '每次6g',
  MCJK = '每次9g',
  MCSKG = '每次10g',
  MCSRK = '每次12g',
  MCSWG = '每次15g',
  MCYW = '1丸',
  MCLW = '2丸',
  MCWW = '5丸',
  MCSW = '10丸',
  MCESW = '20丸',
  MCWSW = '30丸',
  MCSL = '适量',
}

export const RecipeTabletManufacturingNumCategories = [
  RecipeTabletManufacturingNumCategory.MCSK,
  RecipeTabletManufacturingNumCategory.MCLK,
  RecipeTabletManufacturingNumCategory.MCJK,
  RecipeTabletManufacturingNumCategory.MCSKG,
  RecipeTabletManufacturingNumCategory.MCSRK,
  RecipeTabletManufacturingNumCategory.MCSWG,
  RecipeTabletManufacturingNumCategory.MCYW,
  RecipeTabletManufacturingNumCategory.MCLW,
  RecipeTabletManufacturingNumCategory.MCWW,
  RecipeTabletManufacturingNumCategory.MCSW,
  RecipeTabletManufacturingNumCategory.MCESW,
  RecipeTabletManufacturingNumCategory.MCWSW,
  RecipeTabletManufacturingNumCategory.MCSL,
]

export function RecipeTabletManufacturingNumName(
  recipeTabletManufacturing: RecipeTabletManufacturingNumCategory
): string {
  switch (recipeTabletManufacturing) {
    case '每次3g':
      return '每次3g'
    case '每次6g':
      return '每次6g'
    case '每次9g':
      return '每次9g'
    case '每次10g':
      return '每次10g'
    case '每次12g':
      return '每次12g'
    case '每次15g':
      return '每次15g'
    case '1丸':
      return '1丸'
    case '2丸':
      return '2丸'
    case '5丸':
      return '5丸'
    case '10丸':
      return '10丸'
    case '20丸':
      return '20丸'
    case '30丸':
      return '30丸'
    case '适量':
      return '适量'
  }
  return ''
}

//制膏
export enum RecipePreparationPasteCategory {
  YRYC = '每日一次',
  MRLC = '每日二次',
  MRSC = '每日三次',
  MRSCS = '每日四次',
  MRWC = '每日五次',
  MRLCL = '每日六次',
  LRYC = '两日一次',
  GRYC = '隔日一次',
  YZYC = '每周一次',
  YZLC = '每周两次',
  YZSC = '每周三次',
  GZYC = '隔周一次',
  BYS = '必要时',
  DF = '顿服',
  SLPF = '少量频服',
  SSFY = '随时服用',
}

export const RecipePreparationPasteCategories = [
  RecipePreparationPasteCategory.YRYC,
  RecipePreparationPasteCategory.MRLC,
  RecipePreparationPasteCategory.MRSC,
  RecipePreparationPasteCategory.MRSCS,
  RecipePreparationPasteCategory.MRWC,
  RecipePreparationPasteCategory.MRLCL,
  RecipePreparationPasteCategory.LRYC,
  RecipePreparationPasteCategory.GRYC,
  RecipePreparationPasteCategory.YZYC,
  RecipePreparationPasteCategory.YZLC,
  RecipePreparationPasteCategory.YZSC,
  RecipePreparationPasteCategory.GZYC,
  RecipePreparationPasteCategory.BYS,
  RecipePreparationPasteCategory.DF,
  RecipePreparationPasteCategory.SLPF,
  RecipePreparationPasteCategory.SSFY,
]

export function RecipePreparationPasteName(
  recipePreparationPaste: RecipePreparationPasteCategory
): string {
  switch (recipePreparationPaste) {
    case '每日一次':
      return '每日一次'
    case '每日二次':
      return '每日二次'
    case '每日三次':
      return '每日三次'
    case '每日四次':
      return '每日四次'
    case '每日五次':
      return '每日五次'
    case '每日六次':
      return '每日六次'
    case '两日一次':
      return '两日一次'
    case '隔日一次':
      return '隔日一次'
    case '每周一次':
      return '每周一次'
    case '每周两次':
      return '每周两次'
    case '每周三次':
      return '每周三次'
    case '隔周一次':
      return '隔周一次'
    case '必要时':
      return '必要时'
    case '顿服':
      return '顿服'
    case '少量频服':
      return '少量频服'
    case '随时服用':
      return '随时服用'
  }
  return ''
}

export enum RecipePreparationPasteNumCategory {
  MCWG = '每次5g',
  MCSG = '每次10g',
  MCSWG = '每次15g',
  MCESG = '每次20g',
  MCESWG = '每次25g',
  MCSSG = '每次30g',
  MCSSWG = '每次35g',
  MCSSGS = '每次40g',
  YTC = '1汤匙',
  ETC = '2汤匙',
  STC = '3汤匙',
  SL = '适量',
}

export const RecipePreparationPasteNumCategories = [
  RecipePreparationPasteNumCategory.MCWG,
  RecipePreparationPasteNumCategory.MCSG,
  RecipePreparationPasteNumCategory.MCSWG,
  RecipePreparationPasteNumCategory.MCESG,
  RecipePreparationPasteNumCategory.MCESWG,
  RecipePreparationPasteNumCategory.MCSSG,
  RecipePreparationPasteNumCategory.MCSSWG,
  RecipePreparationPasteNumCategory.MCSSGS,
  RecipePreparationPasteNumCategory.YTC,
  RecipePreparationPasteNumCategory.ETC,
  RecipePreparationPasteNumCategory.STC,
  RecipePreparationPasteNumCategory.SL,
]

export function RecipePreparationPasteNumName(
  recipePreparationPasteNum: RecipePreparationPasteNumCategory
): string {
  switch (recipePreparationPasteNum) {
    case '每次5g':
      return '每次5g'
    case '每次10g':
      return '每次10g'
    case '每次15g':
      return '每次15g'
    case '每次20g':
      return '每次20g'
    case '每次25g':
      return '每次25g'
    case '每次30g':
      return '每次30g'
    case '每次35g':
      return '每次35g'
    case '每次40g':
      return '每次40g'
    case '1汤匙':
      return '1汤匙'
    case '2汤匙':
      return '2汤匙'
    case '3汤匙':
      return '3汤匙'
    case '适量':
      return '适量'
  }
  return ''
}
